module.exports = __webpack_public_path__ + "static/img/900X3J.6239a95e.png";